var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34425 1.74532C9.24444 1.6675 9.1215 1.62524 8.99494 1.62524C8.86838 1.62524 8.74544 1.6675 8.64563 1.74532L0.5625 8.04813L1.26169 8.93238L2.25 8.16176V15.1249C2.25059 15.4231 2.36931 15.7089 2.58016 15.9198C2.79101 16.1306 3.07681 16.2494 3.375 16.2499H14.625C14.9232 16.2494 15.209 16.1306 15.4198 15.9198C15.6307 15.7089 15.7494 15.4231 15.75 15.1249V8.16682L16.7383 8.93745L17.4375 8.0532L9.34425 1.74532ZM10.125 15.1249H7.875V10.6249H10.125V15.1249ZM11.25 15.1249V10.6249C11.2497 10.3267 11.1311 10.0407 10.9202 9.82978C10.7093 9.61887 10.4233 9.50024 10.125 9.49995H7.875C7.57672 9.50024 7.29075 9.61887 7.07983 9.82978C6.86892 10.0407 6.7503 10.3267 6.75 10.6249V15.1249H3.375V7.28482L9 2.90295L14.625 7.29045V15.1249H11.25Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic-1.bbe1fe4f91427e8c48488192063e3fef.svg";
export { ForwardRef as ReactComponent };